export const LETTERS = ['所有品牌', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
export const switchDataType = (type) => {
  switch (type) {
    case 'Text': return 'String'
    case 'Enum': return 'Enums'
    case 'Number': return 'Double'
    case 'Bool': return 'Integer'
    case 'Int': return 'Integer'
    default: return type
  }
}
export const productMenuIcon = {
  C000001: 'gjw-icon-tongfengji',
  C000002: 'gjw-icon-shuibeng',
  C000005: 'gjw-icon-duolianji',
  C000006: 'gjw-icon-fengjipanguan',
  C000007: 'gjw-icon-bianpingeishuijizu',
  C000008: 'gjw-icon-dengju',
  C000009: 'gjw-icon-lengshuijizu',
  C000010: 'gjw-icon-rebeng',
  C000011: 'gjw-icon-kongqichuliqi',
  C000012: 'gjw-icon-moduanfengkou',
  C000013: 'gjw-icon-lengqueta',
  C000014: 'gjw-icon-guolu',
  C000015: 'gjw-icon-paiqishan',
  C000016: 'gjw-icon-bianyaqi',
  C000017: 'gjw-icon-reshuijizu',
}
